const folderTypes = {
  FOUNDER_FOLDER: 1,
  CLIENT_FOLDER: 2,
  MAIN_FOLDER: 3,
  EMPLOYEE_FOLDER: 4,
  PERSONAL_FOLDER: 5
}

export default folderTypes



// WEBPACK FOOTER //
// ./src/constants/folderTypes.js